import React from 'react'
import styled from 'styled-components'

const Div = styled.div`
  margin: ${props => props.margin || '4rem 0'};
  font-size: 2rem;
  font-family: "HelveticaNeueLTStd-Roman", sans-serif;
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 1.8rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`

const Footer = (props) => (
  <Div {...props}>
    {props.children}
  </Div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js